import { StripeInstance } from 'ngx-stripe';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StripeTokenService {
  url = environment.api;
  constructor(
    private http: HttpClient,
  ) {}
  externalId: string = '';
  stripe!: StripeInstance;

  testStripeApi(stripe: any, card: any): Observable<any> {
    // Note: returns either a string token id OR an object { error } when token creation fails
    return new Observable<any>((observer) => {
      this.externalId = localStorage.getItem('tokenCorrelative') ?? '';
      const name = localStorage.getItem('fullName') + '/' + this.externalId;
      stripe
        .createToken(card.element, { name: name })
        .subscribe((result: any) => {
          if (result.token) {
            observer.next(result.token.id);
            observer.complete();
          } else if (result.error) {
            // Return the error object so callers can inspect decline_code, seller_message, etc.
            console.error('Error creating the token:', result.error.message);
            observer.next({ error: result.error });
            observer.complete();
          }
        });
    });
  }

  /**
   * Fetch a Stripe setting by id from the backend.
   * If no id is provided, attempt to read `settingStripeId` from localStorage.
   * Returns of(null) when no id is available.
   */
  getStripeSetting(settingStripeId?: string): Observable<any> {
    // Only use the explicit settingStripeId passed by callers. Do not read from localStorage.
    if (!settingStripeId) {
      return of(null);
    }

    const endpoint = `${this.url}/api/v1/stripe/${settingStripeId}`;
    return this.http.get(endpoint).pipe(
      tap((resp: any) => {
        // Log the response to verify the shape
        console.log('[StripeTokenService] getStripeSetting response:', resp);

        const data = resp?.data ?? resp?.response ?? resp;
        if (data && data.publishableKey) {
          localStorage.setItem('stripePublishableKey', data.publishableKey);
          console.log(
            '[StripeTokenService] Updated stripePublishableKey in localStorage:',
            data.publishableKey,
          );
        }
      }),
    );
  }
}
